import { Component, Input } from "@angular/core";
import { UserSearchResult } from "@apiserver-rest/ponder-data-client-base";
import { getProfileImageRoute } from "../profile/profile-image-router";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "user-friend-add-row",
    imports: [],
    templateUrl: "./user-friend-add-row.component.html"
})
export class UserFriendAddRowComponent {
    @Input({ required: true }) public userInfo!: UserSearchResult;

    public avatarUrl!: string;
    public username!: string;
    public displayName!: string;

    constructor(private events: EventBroker) {

    }

    public ngOnInit(): void {
        this.username = this.userInfo.username!;
        this.displayName = this.userInfo.displayName ?? this.username;
        this.avatarUrl = getProfileImageRoute(this.username);
    }

    public onClick(): void {
        this.events.profile.addFriendEvent.emit(this.userInfo.userId);
    }
}